import { render, staticRenderFns } from "./PurchasersUpdateModal.vue?vue&type=template&id=4a2af2b1&"
import script from "./PurchasersUpdateModal.vue?vue&type=script&lang=js&"
export * from "./PurchasersUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports